export default "__VITE_ASSET__B_XsReu2__"